import { c as _c } from "react/compiler-runtime";
interface RangeStepsProps {
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}
const generateStepHeight = (isMajorStep: boolean) => {
  if (isMajorStep) {
    return 6;
  }
  return 4;
};
function RangeSteps(t0) {
  const $ = _c(9);
  const {
    min: t1,
    max: t2,
    step: t3,
    className
  } = t0;
  const min = t1 === undefined ? 0 : t1;
  const max = t2 === undefined ? 100 : t2;
  const step = t3 === undefined ? 10 : t3;
  const numSteps = (max - min) / step;
  const t4 = `w-full flex justify-between ${className}`;
  let t5;
  if ($[0] !== numSteps) {
    t5 = Array.from({
      length: numSteps + 1
    });
    $[0] = numSteps;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== numSteps || $[3] !== step || $[4] !== t5) {
    t6 = t5.map((_, index) => {
      const isMajorStep = index === 0 || index === numSteps || (index + 1) * step % 1000 === 0;
      const isMajorMobileStep = index === 0 || index === numSteps || (index + 1) * step % 2000 === 0;
      return <div key={index} className="relative flex-1 min-w-0 flex flex-col items-center"><div className={`h-${generateStepHeight(isMajorStep)} w-px bg-primary`} />{isMajorStep && <span className={`absolute top-full mt-2 text-xs whitespace-nowrap opacity-${isMajorMobileStep ? 100 : 0} md:opacity-100`}>{new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP",
            maximumFractionDigits: 0
          }).format((index + 1) * step)}</span>}</div>;
    });
    $[2] = numSteps;
    $[3] = step;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[6] = t4;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}
export { RangeSteps };